export const API_CONSTANTS = {
	API_URL: import.meta.env.VITE_API_URL,
	API_ENV: import.meta.env.VITE_SENTRY_ENV,
	SENTRY_AUTH_TOKEN: import.meta.env.VITE_SENTRY_AUTH_TOKEN,
	API_WS_URL: import.meta.env.VITE_WS_URL
};